var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiameter = function SvgDiameter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3699",
    transform: "translate(-303 -1759)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#ebebeb",
    "data-name": "Ellipse 677",
    transform: "translate(303 1759)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3599",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3597"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M348.788 1789.659h-1.617l-.006-5.257-5.257-.006v-1.616l6.88-.001Z",
    "data-name": "Path 4411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5,
    d: "m348.075 1783.492-10.606 10.606",
    "data-name": "Line 1709"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3598"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M333.742 1804.705v-1.617l-5.257-.005-.006-5.258h-1.616v6.88Z",
    "data-name": "Path 4411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5,
    d: "m327.575 1803.992 10.606-10.607",
    "data-name": "Line 1709"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3600"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m353.104 1780.42-4.6-1.744-.474-9.676c2.032 0 3.046.53 3.046 2.561Z",
    "data-name": "Path 4422",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m323.002 1780.42 4.6-1.744.474-9.676c-2.032 0-3.046.53-3.046 2.561Z",
    "data-name": "Path 4423",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m323 1807.619 4.593 1.744.474 9.672c-2.031 0-3.045-.529-3.045-2.56Z",
    "data-name": "Path 4424",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m353.09 1807.619-4.593 1.744-.474 9.672c2.031 0 3.044-.529 3.044-2.56Z",
    "data-name": "Path 4425",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0e2240",
    strokeWidth: 3,
    "data-name": "Ellipse 687",
    transform: "translate(317 1773.273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.586,
    cy: 20.586,
    r: 20.586,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.586,
    cy: 20.586,
    r: 19.086
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M358.413 1789h2.227a.16.16 0 0 1 .162.162v9.084a.163.163 0 0 1-.163.163h-2.226a.163.163 0 0 1-.163-.163v-9.083a.163.163 0 0 1 .163-.163",
    "data-name": "Rectangle 4702",
    opacity: 0.5
  }))));
};
export { SvgDiameter as ReactComponent };
export default "/_next/static/images/diameter.svg";